// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"ActionReplays_sliderContainer__2Stnt","actionReplayItem":"ActionReplays_actionReplayItem__28u5z"};